import { colorBrandPrimary } from 'src/global.style'
import styled from 'styled-components'

const distance = '1.5rem'

export const Container = styled.div`
	max-width: 26.25rem;
	min-width: 13rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: ${distance} 0;
	padding-bottom: 0.5rem;

`
export const CardHeader = styled.div`
	width: 16.5rem;
	height: 11rem;
	background: #ffffff;
	border-radius: 1rem;
	opacity: 1;
	margin-bottom: -15px;
	z-index: 3;
	position: relative;
	.subtitle {
		padding-top: 0.75rem;
		text-align: center;
		font-family: 'Galano Grotesque Alt';
		font-size: 1.25rem;
		opacity: 1;
		color: ${({ blur }) => (blur ? 'transparent' : '#3878BF')};
		text-shadow: ${({ blur }) => (blur ? `0 0 4px #3878BF` : 'none')};
		user-select: ${({ blur }) => (blur ? 'none' : 'auto')};
	}
	p {
		padding-top: 0.75rem;
		font-size: 1rem;
		text-align: center;
		color: ${({ blur }) => (blur ? 'transparent' : '#3878BF')};
		text-shadow: ${({ blur }) => (blur ? `0 0 4px #3878BF` : 'none')};
		user-select: ${({ blur }) => (blur ? 'none' : 'auto')};
	}
`
export const CardBody = styled.div`
	z-index: 1;
	width: 16.5rem;
	background: #ffffff;
	border: 2px solid #e2e1eb;
	border-radius: 0px 0px 10px 10px;
	opacity: 1;
`
export const Title = styled.div`
	padding-top: 1.75rem;
	padding-left: 1rem;
	font-size: 1.5rem;
	font-family: 'Galano Grotesque Alt';
	color: #232323;
	text-align: left;
	width: 100%;
`
export const Banner = styled.div`
	width: 100%;
	border-radius: 0.5rem;
	max-height: 7.625rem;
	overflow: hidden;

	display: grid;
	place-items: initial;
`
export const Benefits = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	hr {
		width: 100%;
		border: 0;
		border-top: 2px solid rgb(88, 83, 128);
		opacity: 0.16;
	}
	background-color: #ffffff;
`
export const Benefit = styled.div`
	font-family: ${props => props.bold && '"Galano Grotesque Alt"'};
	font-size: ${props => (props.bold ? '1.25rem' : '1rem')};
	color: ${({ blur }) =>
		blur ? 'transparent' : colorBrandPrimary.marine};
	width: 100%;
	text-align: left;
	text-shadow: ${({ blur }) =>
		blur ? `0 0 8px ${colorBrandPrimary.marine}` : 'none'};
`
export const Item = styled.div`
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: 0.75rem;
	width: 100%;
	img {
		padding-left: 0.875rem;
	}
`
export const Badge = styled.div`
	position: absolute;
	z-index: 2;
	top: -10px;
	left: 20px;
	width: 125px;
	height: 29px;

	background: #3878bf;
	border-radius: 20px;

	p {
		font-family: 'Open Sans';
		font-size: 0.75rem;
		color: #ffffff;
		text-align: left;
		padding: 0.375rem 0.75rem;
	}
`
